import { ReactNode } from 'react';

interface DefaultLayoutProps {
  children: ReactNode;
  Header: ReactNode;
  Footer: ReactNode;
}

export default function DefaultLayout({ children, Header, Footer }: DefaultLayoutProps) {
  return (
    <div className="default-layout">
      {Header}
      <main className="default-main">
        {children}
      </main>
      {Footer}
    </div>
  );
}
